import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="./facebook.png"
								alt="facebook"
								className="work-image"
							/>
							<div className="work-title">Lengo Sacco Ltd</div>
							<div className="work-subtitle">
								Software Engineer Intern
							</div>
							<div className="work-duration">Jan 2026 - Present</div>
						</div>

						<div className="work">
							<img
								src="./KamiLimu.png"
								alt="twitter"
								className="work-image"
							/>
							<div className="work-title">KamiLimu</div>
							<div className="work-subtitle">
								Cohort 9 Mentee
							</div>
							<div className="work-duration">Mar 2025 - Nov 2025</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
